const { Card } = require('@andes/card');
const { Typography } = require('@andes/typography');
const { List, ListItem } = require('@andes/list');
const { Thumbnail } = require('@andes/thumbnail');
const { Pill } = require('@andes/badge');
const { useI18n } = require('nordic/i18n');
const MercadoPagoYellow = require('@cow/core-components/components/Icons/MercadoPagoYellow');

const { generateIcon } = require('../../../utils/icons');
const translate = require('../../../translation');

export const UserTypeMobile = ({
  rebrandingMP,
  isProtected,
  handleNextStep,
}) => {
  const { i18n } = useI18n();
  const translations = translate(i18n);

  const classRebranding = rebrandingMP
    ? 'shipping-rebrand-color'
    : 'shipping-icon-user';

  const initSessionLabel = isProtected
    ? translations.LOGIN_WITH_MY_ACCOUNT
    : translations.LOG_IN_WITH_YOUR_MERCADO_PAGO_ACCOUNT;

  const mpIcon = rebrandingMP ? (
    <MercadoPagoYellow />
  ) : (
    <Thumbnail
      className="shipping-icon-container"
      size="40"
      srLabel="icon_mercado_pago"
    >
      {generateIcon({ type: 'icon_mercado_pago', className: classRebranding })}
    </Thumbnail>
  );

  const protectedPurchase = (
    <Pill
      className="is-bpp-tag"
      size="small"
      roundedCorners={['bottom-left', 'top-right']}
    >
      {translations.PROTECTED_PURCHASE}
      {generateIcon({ type: 'icon_shield_bpp_white' })}
    </Pill>
  );

  return (
    <section className="shipping-user-type-container-v2">
      <Card shadow="elevated">
        <List className={isProtected && 'logged-card'}>
          <ListItem
            srLabel={translations.LOGIN_WITH_MY_ACCOUNT}
            className={isProtected ? 'is-bpp-option' : ''}
            chevron
            title={initSessionLabel}
            description={
              isProtected && (
                <Typography
                  component="p"
                  type="body"
                  size="s"
                  color="secondary"
                >
                  {
                    translations.IF_YOUR_PACKAGE_DOES_NOT_ARRIVE_WE_WILL_REFUND_YOUR_MONEY
                  }
                </Typography>
              )
            }
            leftContent={mpIcon}
            rightContent={isProtected && protectedPurchase}
            rightContentPosition="top"
            onClick={() => handleNextStep('login_user_row_id')}
          />
        </List>
      </Card>

      <Card shadow="elevated">
        <List className="guest-card">
          <ListItem
            paddingSize="24"
            srLabel={translations.CONTINUAR_SIN_CUENTA}
            title={translations.CONTINUAR_SIN_CUENTA}
            leftContent={
              <Thumbnail
                className="shipping-icon-container"
                size="40"
                srLabel="icon_user"
              >
                {generateIcon({
                  type: 'icon_user',
                  className: classRebranding,
                })}
              </Thumbnail>
            }
            onClick={() => handleNextStep('guest_user_row_id')}
            chevron
          />
        </List>
      </Card>
    </section>
  );
};
